import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Порядок важливий: токени → шрифти → глобальні стилі.
import './styles/tokens.css'
import './styles/fonts.css'
import './styles/global.css'

import { initGTM } from './analytics/gtm.js'
import App from './App.jsx'

// Ініціалізація аналітики до рендера (no-op, якщо VITE_GTM_ID порожній).
initGTM()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
